import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class ButtonGroup extends React.Component {
  render() {
    const buttonGroupClasses = classNames(
      "button-group",
      {
        vertical: this.props.vertical,
        join: this.props.isJoin
      },
      this.props.className
    );

    return React.createElement(
      "div",
      {
        className: buttonGroupClasses
      },
      this.props.children
    );
  }
}

ButtonGroup.defaultProps = {
  vertical: false,
  isJoin: false,
  className: null,
  children: null
};

ButtonGroup.propTypes = {
  vertical: PropTypes.bool,
  isJoin: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.node
};

export default ButtonGroup;
